export default class SplashTestimonials {
  constructor(testimonials) {
    this.testimonials = testimonials;
    this.quoteArea = document.querySelector('.testimonial-con .quote');
    this.currentTestimonial = 0;
    this.testimonialInitialization();
    this.initializeEvents();
  }

  initializeEvents() {
    const buttons = {
      '.mobile-testimonial-controls .l-button': 'left',
      '.l-button-desktop': 'left',
      '.mobile-testimonial-controls .r-button': 'right',
      '.r-button-desktop': 'right',
    };

    Object.keys(buttons).forEach(button => {
      document.querySelector(button)
        .addEventListener('click', e => this.testimonialAction(e, buttons[button]));
    });
  }

  removeChildNodes(node) {
    while (node.firstChild) {
      node.removeChild(node.lastChild);
    }
  }

  setTestimonial(testimonial) {
    this.removeChildNodes(this.quoteArea);

    if(testimonial.name) {
      const h3 = document.createElement('h3');
      h3.appendChild(document.createTextNode(testimonial.name));
      this.quoteArea.appendChild(h3);
    }

    if(testimonial.title) {
      const h4 = document.createElement('h4');
      h4.appendChild(document.createTextNode(testimonial.title));
      this.quoteArea.appendChild(h4);
    }

    if(testimonial.testimonial) {
      const body = document.createElement('div');
      body.innerHTML = testimonial.testimonial;
      this.quoteArea.appendChild(body);
    }
  }

  testimonialAction(e, action) {
    e.preventDefault();

    if (action === 'left') {
      this.currentTestimonial = this.currentTestimonial <= 0 ?
        this.testimonials.length - 1 : this.currentTestimonial - 1;
    }

    if (action === 'right') {
      if (this.currentTestimonial >= this.testimonials.length - 1) {
        this.currentTestimonial = 0;
      } else {
        this.currentTestimonial++;
      }
    }
    console.log(this.currentTestimonial);
    this.setTestimonial(this.testimonials[this.currentTestimonial]);
  }

  testimonialInitialization () {
    this.quoteArea.classList.remove('disabled');

    this.setTestimonial(this.testimonials[this.currentTestimonial]);
  }
}



// WEBPACK FOOTER //
// ./scripts/lib/SplashTestimonials.js